export interface ModifierGroup<TModifier> {
  /** The salary setting's id, or null for the company-wide group. */
  salaryWorkTimeId: string | null
  name: string
  modifiers: TModifier[]
}

interface GroupedModifier {
  salaryWorkTime: { id: string; name: string } | null
}

/** Company-wide modifiers first, then one group per salary setting in the
 * order given, the same order the engine applies them in. A modifier on a
 * setting outside the list gets a group of its own at the end. */
export function groupModifiers<TModifier extends GroupedModifier>(
  modifiers: TModifier[],
  salaryWorkTimes: { id: string; name: string }[],
  companyWideName: string
): ModifierGroup<TModifier>[] {
  const groups: ModifierGroup<TModifier>[] = [
    { salaryWorkTimeId: null, name: companyWideName, modifiers: [] },
    ...salaryWorkTimes.map(salaryWorkTime => ({
      salaryWorkTimeId: salaryWorkTime.id,
      name: salaryWorkTime.name,
      modifiers: [],
    })),
  ]
  for (const modifier of modifiers) {
    const id = modifier.salaryWorkTime?.id ?? null
    let group = groups.find(candidate => candidate.salaryWorkTimeId === id)
    if (!group && modifier.salaryWorkTime) {
      group = {
        salaryWorkTimeId: modifier.salaryWorkTime.id,
        name: modifier.salaryWorkTime.name,
        modifiers: [],
      }
      groups.push(group)
    }
    group?.modifiers.push(modifier)
  }
  return groups
}
